import { Immutable } from "immer";
import React, { type ReactNode } from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { IMenuFooter } from "../../utils/menu.interface";

import styles from "./index.module.scss";

type IProps = Immutable<{
    navFooterEl: IMenuFooter;
}>;

export function NavFooter({ navFooterEl }: IProps): ReactNode {
    let link;
    let imageContent: React.JSX.Element | null = null;
    let customHTMLContent: React.JSX.Element | null = null;

    if (navFooterEl.value.page || navFooterEl.value.external_link) {
        link = navFooterEl.value.page
            ? navFooterEl.value.page.url
            : navFooterEl.value.external_link;
    }

    if (navFooterEl.value.image !== null) {
        if (navFooterEl.value.image.url) {
            imageContent = (
                <div className={styles.mainDropdownMenuFooterImageContainer}>
                    <img
                        className={concatClassNames([
                            styles.mainDropdownMenuFooterImage,
                            "responsive-img",
                        ])}
                        src={navFooterEl.value.image.url}
                        alt={navFooterEl.value.image.title}
                    />
                </div>
            );
        }
    }

    if (navFooterEl.value.copy) {
        customHTMLContent = (
            <div
                className={styles.mainDropdownMenuFooterContent}
                dangerouslySetInnerHTML={{
                    __html: navFooterEl.value.copy,
                }}
            ></div>
        );
    }

    if (link) {
        // Need link title since content is an image. See #13290
        return (
            <a href={link} className={styles.mainDropdownMenuFooterItem}>
                {imageContent}
                {customHTMLContent}
            </a>
        );
    }

    return (
        <div className={styles.mainDropdownMenuFooterItem}>
            {imageContent}
            {customHTMLContent}
        </div>
    );
}
